import {Component, Input, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import {BaseComponent} from "@wms/components";

@Component({
  selector: 'wms-user-avatar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './user-avatar.component.html',
  styleUrls: ['./user-avatar.component.less']
})

export class UserAvatarComponent extends BaseComponent implements OnInit{
  userInitials: string;
  name: string;
  customStyle: any;
  @Input() displayName: string;
  @Input() emailId: string;

  profileColors = [
    '6ea74f',
    '97820f',
    'b63c36',
    '3a93ad',
    'af4985'
  ];

  constructor() {
    super();
  }

  ngOnInit() {
    let displayName;
    if (this.displayName) {
      let name = this.displayName.trim().split(' ');
      displayName = name.length > 1 ? name[0][0] + name[1][0] : this.displayName.substr(0, 2);
      this.getNameInitials(displayName, this.displayName, this.emailId);
    } else {
      displayName = this.emailId.substr(0, 2);
      this.getNameInitials(displayName, this.emailId, this.emailId);
    }
  }

  getNameInitials(displayName: any, fullName: any, id: any) {
    let compatibleColors = this.generateCompatibleColors(id);
    this.customStyle = {
      bgStyle: {'backgroundColor': compatibleColors.bg},
      fontStyle: {'color': compatibleColors.font}
    };
    this.userInitials = displayName;
    this.name = fullName;
  }

  generateCompatibleColors(email: any) {
    let fontColor = 'white',
      bgColor = this.getPseudoRandomColor(email);
    return {'bg': '#' + bgColor, 'font': fontColor};
  }

  getPseudoRandomColor(email: any) {
    let uniqueId = this.generateHashCode(email);
    // Get a random color for bg from the array of web safe colors
    return this.profileColors[uniqueId % this.profileColors.length];
  }

  generateHashCode(email: any) {
    if (!email) {
      return 0;
    }
    let hash = 0,
      index,
      charCode;

    for (index = 0; index < email.length; index++) {
      charCode = email.charCodeAt(index);
      hash = ((hash << 5) - hash) + charCode;
    }
    return Math.abs(hash);
  }
}
